import { Component, ElementRef, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { ImageCropperDialogComponent } from 'src/app/components/shared-components/image-cropper-dialog/image-cropper-dialog.component';
import { SnackBarService } from 'src/app/components/shared-components/snack-bar/snack-bar.service';
import { SpinnerService } from 'src/app/components/shared-components/spinner/spinner.service';
import { CenterLite } from 'src/app/models/center-model/center-lite.model';
import { DepartmentsHelpbuttonService } from 'src/app/services/helpbutton-services/departments-helpbutton-service/departments-helpbutton.service';
import { UserStorageService } from 'src/app/services/user-storage-service/user-storage.service';
import { ValidationImageService } from 'src/app/services/validation-images-service/validation-image.service';

@Component({
  selector: 'app-helpbutton-new-department-creation-card',
  templateUrl: './helpbutton-new-department-creation-card.component.html',
  styleUrls: ['./helpbutton-new-department-creation-card.component.scss']
})
export class HelpbuttonNewDepartmentCreationCardComponent implements OnInit, OnDestroy {

  @ViewChild('uploadInput', { static: false }) uploadInput: ElementRef;
  @Input() departmentInfo;
  addNewDepartmentSubscription: Subscription;
  centerInternalId: string;
  centerList: CenterLite[];
  imageBASE64;
  showButton: boolean;
  basicDataForm = new FormGroup({
    departmentName: new FormControl(null, Validators.required),
    location: new FormControl(null, Validators.required),
    active: new FormControl(true),
    selectedCenter: new FormControl(null, Validators.required),
    assistance: new FormControl(false),
    videocall: new FormControl(false),
    voice: new FormControl(false),
    askName: new FormControl(false)
  });
  constructor(private eRef: ElementRef,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private userStorageService: UserStorageService,
    private departmentsService: DepartmentsHelpbuttonService,
    private validationImageService: ValidationImageService,
    private snackbarService: SnackBarService,
    private spinnerService: SpinnerService,
    public dialog: MatDialog) {
    this.showButton = true;
  }

  ngOnInit() {
    this.centerList = this.userStorageService.getCenterList();
    this.basicDataForm.patchValue({
      selectedCenter: this.getSelectedCenterInternalId()
    });
  }

  public addNewDepartment() {
    this.showButton = false;
    this.spinnerService.show('department-new-spinner');
    const validation = this.validateForm();
    if (validation === true) {
      this.addNewDepartmentSubscription = this.departmentsService.addNewDepartment(this.basicDataForm.get('active').value, this.getSelectedCenterInternalId(), this.basicDataForm.get('assistance').value, this.basicDataForm.get('videocall').value, this.basicDataForm.get('voice').value, this.basicDataForm.get('location').value, this.basicDataForm.get('departmentName').value, this.imageBASE64, this.basicDataForm.get('askName').value).subscribe(
        (res) => {
          this.showButton = true;
          this.spinnerService.hide('department-new-spinner');
          this.router.navigate(['../../departments'], { relativeTo: this.activatedRoute });
        },
        (error) => {
          this.showButton = true;
          this.spinnerService.hide('department-new-spinner');
          this.snackbarService.open(error['error']['message'], 'error');
        }
      );
    } else {
      this.showButton = true;
      this.spinnerService.hide('department-new-spinner');
      this.snackbarService.open(validation, 'error');
    }
  }

  public validateForm() {
    if (!this.imageBASE64) {
      return 'helpbutton-page.snackbar messages.image department error';
    } else if (!this.basicDataForm.get('departmentName').valid) {
      return 'helpbutton-page.snackbar messages.name department error';
    } else if (!this.basicDataForm.get('location').valid) {
      return 'helpbutton-page.snackbar messages.location department error';
    } else if (!this.basicDataForm.get('selectedCenter').valid) {
      return 'helpbutton-page.snackbar messages.selected center department error';
    } else {
      return true;
    }
  }

  public getSelectedCenterInternalId() {
    if (this.centerList.length === 1) {
      return this.centerList[0].InternalId;
    } else {
      if (this.basicDataForm.get('selectedCenter').value) {
        return this.basicDataForm.get('selectedCenter').value.InternalId;
      } else {
        return null;
      }
    }
  }

  public uploadPhotoClicker() {
    this.uploadInput.nativeElement.click();
  }

  public uploadAsset(event) {
    const file = event.target.files[0];
    const img = new Image();
    this.validationImageService.toBase64(file).subscribe(
      (base64) => {
        this.imageBASE64 = base64;
        const dialogRef = this.dialog.open(ImageCropperDialogComponent, {
          data: { image: this.imageBASE64, width: 720, height: 300 }
        });
        dialogRef.afterClosed().subscribe(action => { this.imageBASE64 = action; });
      },
      (error) => {
        this.snackbarService.open(error, 'error');
      }
    );
  }

  ngOnDestroy() {
    if (this.addNewDepartmentSubscription) { this.addNewDepartmentSubscription.unsubscribe(); }
  }
}
